"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(_ref) {
  var clockSkewAdjustment = _ref.clockSkewAdjustment;
  return clockSkewAdjustment;
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZWxlY3RvcnMvY2xvY2tTa2V3QWRqdXN0bWVudC5qcyJdLCJuYW1lcyI6WyJjbG9ja1NrZXdBZGp1c3RtZW50Il0sIm1hcHBpbmdzIjoiOzs7Ozs7O2VBQWU7QUFBQSxNQUFHQSxtQkFBSCxRQUFHQSxtQkFBSDtBQUFBLFNBQTZCQSxtQkFBN0I7QUFBQSxDIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgKHsgY2xvY2tTa2V3QWRqdXN0bWVudCB9KSA9PiBjbG9ja1NrZXdBZGp1c3RtZW50O1xuIl19